<template>
  <div class="white">
    <div id="activity"></div>
    <!-- 热门评论  -->
    <comment title="热门评论" :list="hotList" listName="hotList" :isAdmin="isAdmin" v-if="hotList.length" @toPraise="toPraise"
             @del="del" :currentUserName="userObj.nickname" @replyComment="replyComment"
             @toDetails="toDetails" :canLoad="true"></comment>

    <div class="blank" v-if="hotList.length"></div>

    <!-- 最新评论 -->
    <div id="newComment" ref="newComment"></div>
    <comment title="最新评论" :list="newList" listName="newList"  :isAdmin="isAdmin" v-if="newList.length" @toPraise="toPraise2"
             @del="del2" :currentUserName="userObj.nickname" :canLoad="canLoad" :pageOver="pageOver" @replyComment="replyComment"
             @toDetails="toDetails"></comment>

    <!-- 评论 点赞 -->
    <div class="total flex-center" :class="{'show':fixStyle}">
      <section class=" flex-center" @click="toInput">
        <img class="icon" src="../img/mes.png" alt="">
        <div class="content">评论({{commentNum}})</div>
      </section>
      <div class="line"></div>
      <section class="flex-center" @click="praiseArticle" :class="{'active':isPraise}">
        <div class="bg" :class="{'active':showAnimate}"></div>
        <div class="content">点赞({{praiseNum}})</div>
      </section>
    </div>
    <!-- 没数据  -->
    <div v-if="noData" class="no-mes">快来抢个沙发吧</div>

    <div class="margin"></div>

    <!-- 输入框 -->
    <div class="mask flex-center input-box" v-show="inputShow">
      <div class="flex1" style="width:100%;" @click="hideInput"></div>
      <div class="input-bg flex-center">
        <!-- 输入框 -->
        <section class="flex-center flex1">
          <textarea class="input2" ref="textarea" type="text" id="textarea" v-model="comment"
                    @blur="gotoView" :placeholder="placeholder"></textarea>
        </section>
        <div class="btn" @click="send">发送</div>
      </div>
    </div>

    <confirm :show-confirm="showConfirm" @sure="sure" @cancel="cancel"></confirm>
  </div>
</template>

<script>
  let fn, fn1;
  import {
    apiGetHotCommentListByArticleId,
    apiGetCommentListByArticleId,
    apiAddArticleComment,
    apiDelArticleComment,
    apiUpdateCommentLike,
    apiGetPlayer,
    apiCheckUserIsAdmin
  } from '../api';
  import comment from './common/comment.vue';
  import confirm from './common/confirm';

  import { autoTextarea } from '../js/tools';
  import { throttle } from 'UTILS/utils';
  import { KEY, getKey, ENV, imgDomain, curScheme, project } from 'CONFIG/config';

  export default {
    components: {
      comment, confirm
    },
    data () {
      return {
        hotList: [], // 热门评论
        newList: [], // 最新评论

        commentNum: 0,   // 总评论数
        praiseNum: 0,    //  总点赞数
        isPraise: false, // 总点赞
        showAnimate: false, // 总点赞动画

        inputShow: false, // 输入框
        comment: '',  // 评论内容
        // 分页
        canLoad: true, // 滚动加载
        pageNum: 1,
        pageSize: 20,
        pageOver: false, // 没数据了
        first: true, // 第一次加载数据
        noData: false, // 暂无数据
        //
        articleId: '', // 文章id
        fixStyle: false,
        userObj: {}, // 用户数据
        newCommentHeight: 0, // 返回最新评论处
        confirmObj: {
          showConfirm: false, // 弹窗
        },
        canPraise: true, // 快速点赞限制
        showConfirm: false,
        offline: false, // 断网
        isAdmin: false, // 超级管理员
        delType: '', // 删除热门评论或最新评论   hot new
        placeholder: '',
        replyName: '',  // 回复 某人
        replyId: '', // 回复 id
        parentId: ''
      };
    },

    mounted () {
      // 断网监听
      window.addEventListener('offline', () => {
        this.offline = true;
      });
      window.addEventListener('online', () => {
        this.offline = false;
      });

      // 入口初始化
      this.init();
    },
    destroyed () {
      this.offScroll();
    },
    methods: {
      // init
      async init () {
        this.pageInit();  // 页面初始化
        this.scrollListener(); // 滚动监听

        if(!KEY){
          try{
            await getKey(2500);
            this.getData();
          } catch (err) {
            this.commonAPi();
          }
        } else {
          this.getData();
        }
      },
      // 页面初始化
      pageInit () {
        // 计算添加评论时需要滚动的位置
        this.newCommentHeight = document.getElementById('newComment').offsetTop;
      },
      //
      async commonAPi () {
        this.articleId = +this.getArticleId();
        await this.getHotComment(); // 热门评论
        await this.getArticleComment(); //  最新评论
        this.scrollListener2(); // 滚动监听加载数据
      },
      // 获取数据
      async getData () {
        this.userObj = await this.getUser() || {}; // 获取用户信息
        this.commonAPi();
      },

      // 获取 articleId
      getArticleId () {
        return document.querySelector('#article_id').value;
      },
      // 用户数据 TODO
      getUser () {
        return apiGetPlayer().then(res => {
          return res.player;
        }).catch(err => {
          console.log('err', err);
        });
      },

      // 判断用户是否有管理员权限 TODO
      isManager () {
        return apiCheckUserIsAdmin({}).then(res => {
          return res.isAdmin;
        }).catch(err => {
          console.log('err', err);
        });
      },

      // 获取文章的热门评论
      getHotComment () {
        apiGetHotCommentListByArticleId({
          userId: +this.userObj.id || 0,
          articleId: this.articleId
        }).then(res => {
          res = res.commentList;

          this.hotList = this.dataProcess(res);
        }).catch(err => {
        });
      },

      // 获取文章的评论列表
      getArticleComment (id) {
        let s = this;
        this.canLoad = false;
        apiGetCommentListByArticleId({
          userId: +this.userObj.id || 0,             // '用户id'
          articleId: this.articleId,          // '文章id',
          parentId: +this.parentId || 0,            // '父评论id，没有则为0',
          lastId: id || 0,            // '上一条展示的评论id，没有则为0',
          pageSize: this.pageSize                    //   '一次获取的评论条数'
        }).then(res => {
          this.canLoad = true;
          if (s.first) {
            // 底部的评论点赞
            this.commentNum = res.commentCount;
            this.praiseNum = res.likeCount;
            this.isPraise = res.like;  // 点赞
          }
          // 列表数据
          let data = res.commentList;
          if (data.length === s.pageSize) {
            s.pageOver = false;
            s.pageNum++;
          } else {
            s.pageOver = true;
            if (s.first) {
              if (!data.length) {
                s.noData = true;
              }
            }
          }
          s.first = false;
          // 如果该评论是热门评论，就不要出现在最新评论
          if (this.hotList.length) {
            for (let i = 0; i < this.hotList.length; i++) {
              for (let j = 0; j < data.length; j++) {
                if (this.hotList[i].id === data[j].id) {
                  data.splice(j, 1);
                  break;
                }
              }
            }
          }
          // 子评论标记自己
          data.forEach(val => {
            val.childComment.forEach(val2 => {
              if (val2.userId === this.userObj.id) {
                val2.isMySelf = true;  // 标记自己
              }
            });
          });
          s.newList = s.newList.concat(this.dataProcess(data));
        }).catch(err => {
          this.canLoad = true;
          console.log('err', err);
        });
      },

      // 数据处理
      dataProcess (data) {
        // 数据处理
        for (var i = 0; i < data.length; i++) {
          data[i].type = data[i].wealthlEvel >= data[i].charmLevel ? 'wealth' : 'charm';
          let val = data[i].wealthlEvel >= data[i].charmLevel ? data[i].wealthlEvel : data[i].charmLevel;
          // 判断颜色等级
          /*
          *  相同点
          *  1-9   level = 1
          *  10-19 level = 2
          *  20-29 level = 3

          * 1.富豪等级
          *  30-34 level = 4
          *  35-40 level = 5
          * 2. 魅力等级
          *  30-39 level = 4
          *  40-50 level = 5
          * */
          //  相同点
          if (val < 10) {
            data[i].level = 1;  // 5种颜色
          } else if (val < 20) {
            data[i].level = 2;
          } else if (val < 30) {
            data[i].level = 3;
          } else {
            // 不同点
            if (data[i].type === 'wealth') {
              if (val < 35) {
                data[i].level = 4;
              } else {
                data[i].level = 5;
              }
            } else {
              if (val < 39) {
                data[i].level = 4;
              } else {
                data[i].level = 5;
              }
            }
          }

          data[i].levelNum = val;
          data[i].showDel = data[i].userId === this.userObj.id;
        }
        return data;
      },

      // 页面滚动监听
      scrollListener () {
        let s = this;
        let activity = document.getElementById('activity');
        var top = 0;
        var divTop = activity.offsetTop;  // 元素top
        var innerHeight = window.innerHeight;   // 窗体高度
        // 如果内容不满屏，直接显示
        if (divTop < innerHeight) {
          s.fixStyle = true;
          return;
        }
        // throttle
        fn = throttle(function () {
          top = document.documentElement.scrollTop || document.body.scrollTop;  // 窗口整体滚动
          s.fixStyle = top > divTop - window.innerHeight;
        }, 300);
        window.addEventListener('scroll', fn, false);
      },

      // 分页监听
      scrollListener2 () {
        let s = this;
        let innerHeight = window.innerHeight;   // 窗体高度
        let top, scrollHeight;
        fn1 = throttle(function () {
          top = document.documentElement.scrollTop || document.body.scrollTop;  // 窗口整体滚动
          scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
          if (top > scrollHeight - 2 * innerHeight && (s.canLoad && !s.pageOver)) {    //  多减一次屏幕高度，提前加载数据
            let item = s.newList[s.newList.length - 1];
            let itemId = item ? item.id : 0;
            s.getArticleComment(itemId);
          }
        }, 300);
        window.addEventListener('scroll', fn1, false);
      },

      // 开始输入
      toInput () {
        this.inputShow = true;
        this.$nextTick(() => {
          var text = document.getElementById('textarea');
          this.$refs.textarea.focus();
          setTimeout(() => {
            document.documentElement.scrollTop = document.body.scrollTop = document.documentElement.scrollHeight - window.innerHeight;
          }, 200);
          autoTextarea(text, 0, 110);// 调用  110是5行显示
        });
      },
      // 解决 ios 点击键盘完成后，点击事件无效
      gotoView (event) {
        let This = event.currentTarget;
        setTimeout(() => {
          This.scrollIntoView({
            block: 'end',
            behavior: 'smooth'
          });
        }, 500);

        // Fixed IOS 13+，收起输入法，不回复原位
        document.documentElement.scrollTop = document.body.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      },

      // 发送评论
      send () {
        if (!this.comment) return;
        if (!this.userObj.id) {
          this.$toast({content: '请先登录'});
          return;
        }
        if(this.comment.length>250){
          this.$toast({content: '超过250个字数限制，请精简一些再发表吧~'});
          return;
        }
        if (this.offline) {
          this.$toast({content: '无网络连接'});
          return false;
        }

        this.addArticleComment();
      },

      // 添加文章的评论  30秒评论一次  用户可以删除自己的评论
      addArticleComment () {
        apiAddArticleComment({
          articleId: this.articleId,          // '文章id',
          articleName: document.title,       // '文章标题',
          parentId: +this.parentId || 0,            // '父评论id'，没有则为0,
          content: this.comment,          // '评论内容',
          commentUrl: this.getUrl(this.parentId), // 文章url
          toUserId: this.replyId || 0,         // '回复给用户id',
          toUserName: this.replyName,        // '回复给玩家名称',
        }).then(res => {
          // 主页回复评论不用显示出来
          if (this.parentId) {
            this.$toast({content: '评论成功'});
            // 清数据
            this.comment = '';
            this.inputShow = false;
            setTimeout(() => {
              this.toCms2(this.parentId);
            }, 500);
            return;
          }

          // 添加最新评论
          let obj = {
            id: res.id,
            userIcon: this.userObj.icon ? this.userObj.icon : this.$defAvatar,
            userName: this.userObj.nickname,
            nameplateUrl: this.userObj.nameplateUrl,
            hasLike: false,
            likeCount: 0,
            createAt: parseInt(new Date().getTime() / 1000),
            content: this.comment,
            wealthlEvel: this.userObj.wealthLevel,
            charmLevel: this.userObj.charmLevel,
            userId: this.userObj.id,
            articleId: this.articleId
          };
          let data = this.dataProcess([obj]);
          this.newList = [...data, ...this.newList];  // 数据合并
          this.commentNum += 1; // 总评论数+1
          this.noData = false; // 有数据了
          // 滚动条到新加的评论
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs.newComment && window.scrollTo(0, this.$refs.newComment.offsetTop);
            }, 500);
          });
          this.$toast({content: '评论成功'});
          // 清空数据
          this.comment = '';
          this.inputShow = false;
        }).catch(err => {
          this.$toast({content: err.allDescription.desc});
          this.inputShow = false;
        });
      },
      // 跳转评论详情页
      toCms2 (parentId) {
        let url = this.getUrl(parentId)
        console.log('跳的地址',url);
        let scheme = curScheme;
        window.location.href = `${scheme}?dyaction=web&url=${encodeURIComponent(url)}`;
      },
      getUrl(parentId){
        let articleId = this.getArticleId();  // 文件id
        let articleUrl = encodeURIComponent(window.location.href);
        let url = `${imgDomain}/${ENV}/${project}/commonality/cmsDetail/index.html?parentId=${parentId}&articleId=${articleId}&id=${articleId}&articleUrl=${articleUrl}`;

        return url;
      },

      // 文章点赞
      praiseArticle () {
        if (!this.userObj.id) {
          this.$toast({content: '请先登录'});
          return;
        }
        if (this.offline) {
          this.$toast({content: '无网络连接'});
          return false;
        }
        this.updateArticleComment(0);
      },

      // 点赞或者取消点赞   有obj 表示评论
      updateArticleComment (commentId, obj) {
        if (!this.canPraise) return;
        this.canPraise = false;
        apiUpdateCommentLike({
          articleId: this.articleId,         //文章id
          commentId: commentId,         //评论id
          parentCommentId: +this.parentCommentId || 0,   //父评论id，没有则为0
          like: obj ? !obj.hasLike : !this.isPraise                 //true 点赞， false 取消点赞
        }).then(res => {
          // 文章点赞
          if (commentId === 0) {
            this.isPraise = !this.isPraise;  //
            this.showAnimate = !!this.isPraise; // 动画
            if (this.isPraise) {
              this.praiseNum += 1;
            } else {
              this.praiseNum -= 1;
            }
          } else {
            // 评论
            obj.hasLike = !obj.hasLike;
            obj.showAnimate = !!obj.hasLike;
            if (obj.hasLike) {
              obj.likeCount += 1;
            } else {
              obj.likeCount -= 1;
            }
          }
          this.$nextTick(() => {
            this.canPraise = true;
          });
        }).catch(err => {
          this.$toast({content: err.allDescription.desc});
          this.canPraise = true;
          console.log('err', err);
        });
      },
      // 热门评论点赞
      toPraise (obj) {
        if (!this.userObj.id) {
          this.$toast({content: '请先登录'});
          return;
        }
        if (this.offline) {
          this.$toast({content: '无网络连接'});
          return false;
        }

        this.updateArticleComment(obj.id, obj);
      },
      // 最新评论点赞
      toPraise2 (obj) {
        if (!this.userObj.id) {
          this.$toast({content: '请先登录'});
          return;
        }
        if (this.offline) {
          this.$toast({content: '无网络连接'});
          return false;
        }

        this.updateArticleComment(obj.id, obj);

      },
      // 取消监听
      offScroll () {
        window.removeEventListener('scroll', fn, !1);
        window.removeEventListener('scroll', fn1, !1);
      },
      // 热门评论
      del (obj, key) {
        this.showConfirm = true;
        this.confirmObj.obj = obj;
        this.confirmObj.key = key;
        this.delType = 'hot';
      },
      // 最新评论删除
      del2 (obj, key) {
        this.showConfirm = true;
        this.confirmObj.obj = obj;
        this.confirmObj.key = key;
        this.delType = 'new';
      },
      // 确认框
      sure () {
        this.delArticleComment(this.confirmObj.obj, this.confirmObj.key);
      },
      cancel () {
        this.showConfirm = false;
      },

      // 删除文章的评论
      delArticleComment (obj, key) {
        apiDelArticleComment({
          id: obj.id,                  // '评论id'
          articleId: +obj.articleId,          // '文章id',
          parentId: +this.parentId || 0           // '父评论id'，没有则为0,
        }).then(res => {
          this.$toast({content: '删除评论成功'});

          if (this.delType === 'hot') {
            this.hotList.splice(key, 1);
          } else if (this.delType === 'new') {
            this.newList.splice(key, 1);
            this.commentNum -= 1;  // 评论数减一
          }
          this.showConfirm = false;
        }).catch(err => {
          console.log('err', err);
        });
      },
      // 回复
      replyComment (val) {
        this.placeholder = '回复 ' + val.userName + ':';
        this.parentId = val.id;
        this.toInput();
      },
      // 查看评论详情
      toDetails (val) {
        this.toCms2(val.id);
      },
      hideInput(){
        this.inputShow = false;
        // 清空数据
        this.placeholder = '';
        this.parentId = '';
      }

    },
  };
</script>

<style lang="scss" src="../style/index.scss">
</style>

<style lang="scss" scoped>
  .white {
    background: #fff;
  }

  .margin {
    height: 112px;
  }

  // 评论点赞
  .total {
    background: #F6F6F6;
    height: 110px;
    opacity: 0;

    &.show {
      opacity: 1;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 100;
      transition: 1s;
    }

    section {
      justify-content: center;
      font-size: 26px;
      font-weight: 400;
      color: rgba(138, 138, 138, 1);
      height: 37px;
      width: 49%;

      .icon {
        width: 32px;
        height: 32px;
        margin-right: 16px;

      }

      .bg {
        background-image: url("../img/praise-gray.png");
        background-repeat: no-repeat;
        width: 32px;
        height: 32px;
        background-size: 100% 100%;
        margin-right: 16px;

      }

      .content {
        margin-top: 5px;
      }

      &.active {
        color: #FE7C3C;

        .bg {

          background-image: url("../img/praise.png");

          &.active {
            animation: praise .5s linear; // 点赞动画
          }
        }
      }
    }

    .line {
      width: 2px;
      height: 38px;
      background: rgba(0, 0, 0, .2);
    }
  }

  // 空白
  .blank {
    background: #F5F5F5;
    height: 20px;
  }

  // mask
  .mask {
    flex-direction: column;

    .input-bg {
      width: 100%;
      background: #F6F6F6;
      min-height: 112px;
      box-sizing: border-box;
      padding-left: 32px;
      padding-right: 25px;
      // 输入框
      section {
        width: 580px;
        min-height: 72px;
        background: rgba(255, 255, 255, 1);
        border-radius: 36px;
        box-sizing: border-box;
        padding: 0 20px 0 32px;
        margin-top: 13px;
        margin-bottom: 17px;

        .input {
          margin-right: 22px;
          outline: none;
          border: none;
          resize: none; // 取消下右角三角图标
          font-size: 30px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          width: 462px;

        }

        .input2 {
          display: block;
          overflow: hidden;
          width: 512px;
          font-size: 30px;
          height: 18px;
          line-height: 42px;
          padding: 2px;
          outline: none;
          border: none;
        }

        .icon {
          background-image: url("../img/face-gray.png");
          background-repeat: no-repeat;
          width: 44px;
          height: 44px;
          background-size: 100% 100%;

          &.active {
            background-image: url("../img/face.png");
          }
        }
      }

      .btn {
        width: 93px;
        height: 72px;
        background: linear-gradient(222deg, rgba(255, 153, 58, 1) 0%, rgba(254, 124, 60, 1) 100%);
        border-radius: 36px;
        line-height: 72px;
        font-size: 30px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        margin-left: 20px;

      }
    }
  }

  .no-mes {
    text-align: center;
    color: rgba(0, 0, 0, 0.25);
    font-size: 24px;
    line-height: 100px;
  }

</style>
